import { render, staticRenderFns } from "./clientCreateClientForm.vue?vue&type=template&id=07368294&"
import script from "./clientCreateClientForm.vue?vue&type=script&lang=js&"
export * from "./clientCreateClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports